import { render } from "./StackedHorizontalBarchart.vue?vue&type=template&id=330f8626&scoped=true"
import script from "./StackedHorizontalBarchart.vue?vue&type=script&lang=js"
export * from "./StackedHorizontalBarchart.vue?vue&type=script&lang=js"

import "./StackedHorizontalBarchart.vue?vue&type=style&index=0&id=330f8626&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-330f8626"]])

export default __exports__